import React, { Component } from 'react';
import { checkEmailAvailability, checkUsernameAvailability, signup, getRolesForUserPurpose } from '../../util/APIUtils'; 
import './Signup.css';
import { Link } from 'react-router-dom';
import {
    NAME_MAX_LENGTH,
    NAME_MIN_LENGTH,
    PASSWORD_MAX_LENGTH,
    PASSWORD_MIN_LENGTH,
    USERNAME_MAX_LENGTH,
    USERNAME_MIN_LENGTH
} from '../../constants';
import { Button, Form, Input, notification, Icon, Select } from 'antd';
import { Col, Row } from "reactstrap";
import 'antd/es/spin/style/css';
import { validateEmail } from "../../util/Helpers";

const FormItem = Form.Item;
const { Option } = Select;

class Signup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: {
                value: ''
            },
            surname: {
                value: ''
            },
            username: {
                value: ''
            },
            email: {
                value: ''
            },
            password: {
                value: ''
            },
            purpose: {
                value: ''
            },
            purposes: [], // Yeni state değişkeni
            isLoading: false,
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.validateUsernameAvailability = this.validateUsernameAvailability.bind(this);
        this.validateEmailAvailability = this.validateEmailAvailability.bind(this);
        this.isFormInvalid = this.isFormInvalid.bind(this);
    }

    // componentDidMount() {
    //     getRolesForUserPurpose()
    //         .then(response => {
    //             this.setState({
    //                 purposes: response
    //             });
    //         }).catch(error => {
    //             notification.error({
    //                 message: 'ŞanlıUrfa Eczacı Odası',
    //                 description: error.message || 'Amaçlar yüklenirken bir hata oluştu!'
    //             });
    //         });
    // }
    componentDidMount() {
        getRolesForUserPurpose()
            .then(response => {
                this.setState({
                    purposes: response.data // Verinin doğru şekilde yüklendiğinden emin olun
                });
            }).catch(error => {
                notification.error({
                    message: 'ŞanlıUrfa Eczacı Odası',
                    description: error.message || 'Amaçlar yüklenirken bir hata oluştu!'
                });
            });
    }
    
    handleInputChange(event, validationFun) {
        const target = event.target;
        const inputName = target.name;
        const inputValue = target.value;

        this.setState({
            [inputName]: {
                value: inputValue,
                ...validationFun(inputValue)
            }
        });
    }

    handleSelectChange(value) {
        const selectedPurpose = this.state.purposes.find(purpose => purpose.name === value);
        this.setState({
            purpose: {
                value: selectedPurpose,
                validateStatus: 'success',
                errorMsg: null
            }
        });
    }
    
    

    handleSubmit(event) {
        event.preventDefault();

        const signupRequest = {
            name: this.state.name.value,
            surname: this.state.surname.value,
            email: this.state.email.value,
            username: this.state.username.value,
            password: this.state.password.value,
            rolePurpose: this.state.purpose.value,
            webSitesiURL: window.location.hostname
        };
        signup(signupRequest)
            .then(() => {
                this.props.history.push("/login");
                notification.success({
                    message: 'ŞanlıUrfa Eczacı Odası',
                    description: "Tebrikler Başarıyla Kaydoldunuz! Girmiş Olduğunuz E-posta Adresine bir Aktivasyon E-postası Gönderilmiştir. E-postadaki Linke Tıklayarak Hesabınızı Aktive Ediniz!",
                    duration: 30,
                })
            }).catch(error => {
                console.log(error);
                notification.error({
                    message: 'ŞanlıUrfa Eczacı Odası',
                    description: error.message || 'Özür Dilerim. Birşeyler Yanlış Gitti!'
                });
            });
    }

    isFormInvalid() {
        return !(this.state.name.validateStatus === 'success' &&
            this.state.surname.validateStatus === 'success' &&
            this.state.username.validateStatus === 'success' &&
            this.state.email.validateStatus === 'success' &&
            this.state.password.validateStatus === 'success' &&
            this.state.purpose.validateStatus === 'success'
        );
    }

    render() {
        return (
            <Row className='ogo-login-background' style={{backgroundImage: 'url(' + process.env.REACT_APP_CONTEXT_NAME + "/image/background.jpg" + ')', marginLeft: "0px", marginRight: "0px"}}>
                <Col xs='12'>
                    <Col xs='12' style={{padding: '0 0 15px 0', textAlign: 'center'}}>
                        <img src={process.env.REACT_APP_CONTEXT_NAME + "/image/img.png"} alt='oda-logo' className='ogo-login-logo'/>
                    </Col>
                    <div className="signup-content">
                        <Form onSubmit={this.handleSubmit} className="signup-form">
                            <FormItem
                                validateStatus={this.state.name.validateStatus}
                                help={this.state.name.errorMsg}>
                                <Input
                                    prefix={<Icon type="user" />}
                                    size="large"
                                    name="name"
                                    autoComplete="off"
                                    placeholder="Adınız"
                                    value={this.state.name.value}
                                    onChange={(event) => this.handleInputChange(event, this.validateName)}/>
                            </FormItem>
                            <FormItem
                                validateStatus={this.state.surname.validateStatus}
                                help={this.state.surname.errorMsg}>
                                <Input
                                    prefix={<Icon type="user" />}
                                    size="large"
                                    name="surname"
                                    autoComplete="off"
                                    placeholder="Soyadınız"
                                    value={this.state.surname.value}
                                    onChange={(event) => this.handleInputChange(event, this.validateSurname)}/>
                            </FormItem>

                            <FormItem
                                hasFeedback
                                validateStatus={this.state.username.validateStatus}
                                help={this.state.username.errorMsg}>
                                <Input
                                    prefix={<Icon type="user" />}
                                    size="large"
                                    name="username"
                                    autoComplete="off"
                                    placeholder="Kullanıcı Adı"
                                    value={this.state.username.value}
                                    onBlur={this.validateUsernameAvailability}
                                    onChange={(event) => this.handleInputChange(event, this.validateUsername)}/>
                            </FormItem>
                            <FormItem
                                hasFeedback
                                validateStatus={this.state.email.validateStatus}
                                help={this.state.email.errorMsg}>
                                <Input
                                    prefix={<Icon type="mail" />}
                                    size="large"
                                    name="email"
                                    type="email"
                                    autoComplete="off"
                                    placeholder="E-postanız"
                                    value={this.state.email.value}
                                    onBlur={this.validateEmailAvailability}
                                    onChange={(event) => this.handleInputChange(event, validateEmail)}/>
                            </FormItem>
                            <FormItem
                                validateStatus={this.state.password.validateStatus}
                                help={this.state.password.errorMsg}>
                                <Input
                                    prefix={<Icon type="lock" />}
                                    size="large"
                                    name="password"
                                    type="password"
                                    autoComplete="off"
                                    placeholder="6 ile 20 Karakter Arasında Bir Şifre Giriniz."
                                    value={this.state.password.value}
                                    onChange={(event) => this.handleInputChange(event, this.validatePassword)}/>
                            </FormItem>
                            {/* <FormItem
                                validateStatus={this.state.purpose.validateStatus}
                                help={this.state.purpose.errorMsg}>
                                <Select
                                    prefix={<Icon type="solution" />}
                                    name="purpose"
                                    size="large"
                                    placeholder="Hesap Oluşturma Amacınız"
                                    value={this.state.purpose.value ? this.state.purpose.value.name : undefined}
                                    onChange={this.handleSelectChange}
                                    style={{ width: '100%' }}>
                                    {this.state.purposes.length > 0 ? this.state.purposes.map(purpose => (
                                        <Option key={purpose.id} value={purpose.name}>{purpose.name}</Option>
                                    )) : (
                                        <Option key="no_data" value="no_data" disabled>Veri Bulunamadı</Option>
                                    )}
                                </Select>
                            </FormItem> */}

                            <FormItem
                            validateStatus={this.state.purpose.validateStatus}
                            help={this.state.purpose.errorMsg}>
                            <Select
                                prefix={<Icon type="solution" />}
                                name="purpose"
                                size="large"
                                placeholder="Hesap Oluşturma Amacınız"
                                value={this.state.purpose.value ? this.state.purpose.value.name : undefined}
                                onChange={this.handleSelectChange}
                                style={{ width: '100%' }}>
                                {this.state.purposes.length > 0 ? this.state.purposes.map(purpose => (
                                    <Option key={purpose.id} value={purpose.name}>{purpose.name}</Option>
                                )) : (
                                    <Option key="no_data" value="no_data" disabled>Veri Bulunamadı</Option>
                                )}
                            </Select>
                        </FormItem>

                            <FormItem>
                                <Button type="primary"
                                        htmlType="submit"
                                        size="large"
                                        className="signup-form-button"
                                        disabled={this.isFormInvalid()}>Kaydol</Button>
                                Zaten Kayıtlı mısınız? <Link to="/login">Giriş Yapın!</Link>
                            </FormItem>
                        </Form>
                    </div>
                </Col>
            </Row>
        );
    }

    // Validation Functions

    validateName = (name) => {
        if (name.length < NAME_MIN_LENGTH) {
            return {
                validateStatus: 'error',
                errorMsg: `Ad çok kısa: (en az ${NAME_MIN_LENGTH} karakter girilmelidir.)`
            }
        } else if (name.length > NAME_MAX_LENGTH) {
            return {
                validationStatus: 'error',
                errorMsg: `Ad çok uzun (en fazla ${NAME_MAX_LENGTH}  karakter girilmelidir.)`
            }
        } else {
            return {
                validateStatus: 'success',
                errorMsg: null,
            };
        }
    }

    validateSurname = (surname) => {
        if (surname.length < NAME_MIN_LENGTH) {
            return {
                validateStatus: 'error',
                errorMsg: `Soyad çok kısa: (en az ${NAME_MIN_LENGTH} karakter girilmelidir.)`
            }
        } else if (surname.length > NAME_MAX_LENGTH) {
            return {
                validationStatus: 'error',
                errorMsg: `Soyad çok uzun (en fazla ${NAME_MAX_LENGTH}  karakter girilmelidir.)`
            }
        } else {
            return {
                validateStatus: 'success',
                errorMsg: null,
            };
        }
    }

    validateUsername = (username) => {
        console.log("inside validateUsername");
        if (username.length < USERNAME_MIN_LENGTH) {
            return {
                validateStatus: 'error',
                errorMsg: `Kullanıcı adı çok kısa (en az ${USERNAME_MIN_LENGTH} karakter girilmelidir.)`
            }
        } else if (username.length > USERNAME_MAX_LENGTH) {
            return {
                validationStatus: 'error',
                errorMsg: `Kullanıcı adı çok uzun (en fazla ${USERNAME_MAX_LENGTH} karakter girilmelidir.)`
            }
        } else {
            return {
                validateStatus: 'success',
                errorMsg: null
            }
        }
    }

    validateUsernameAvailability() {
        const usernameValue = this.state.username.value;
        const usernameValidation = this.validateUsername(usernameValue);

        if (usernameValidation.validateStatus === 'error') {
            this.setState({
                username: {
                    value: usernameValue,
                    ...usernameValidation
                }
            });
            return;
        }

        this.setState({
            username: {
                value: usernameValue,
                validateStatus: 'validating',
                errorMsg: null
            }
        });

        checkUsernameAvailability(usernameValue)
            .then(response => {
                console.log(response);
                if (response.data.available) {
                    this.setState({
                        username: {
                            value: usernameValue,
                            validateStatus: 'success',
                            errorMsg: null
                        }
                    });
                } else {
                    this.setState({
                        username: {
                            value: usernameValue,
                            validateStatus: 'error',
                            errorMsg: 'Bu kullanıcı adı zaten alınmış!'
                        }
                    });
                }
            }).catch(() => {
                this.setState({
                    username: {
                        value: usernameValue,
                        validateStatus: 'success',
                        errorMsg: null
                    }
                });
            });
    }

    validateEmailAvailability() {
        const emailValue = this.state.email.value;
        const emailValidation = validateEmail(emailValue);

        if (emailValidation.validateStatus === 'error') {
            this.setState({
                email: {
                    value: emailValue,
                    ...emailValidation
                }
            });
            return;
        }

        this.setState({
            email: {
                value: emailValue,
                validateStatus: 'validating',
                errorMsg: null
            }
        });

        checkEmailAvailability(emailValue)
            .then(response => {
                if (response.data.available) {
                    this.setState({
                        email: {
                            value: emailValue,
                            validateStatus: 'success',
                            errorMsg: null
                        }
                    });
                } else {
                    this.setState({
                        email: {
                            value: emailValue,
                            validateStatus: 'error',
                            errorMsg: 'Bu e-posta sistemde kayıtlıdır!'
                        }
                    });
                }
            }).catch(() => {
                this.setState({
                    email: {
                        value: emailValue,
                        validateStatus: 'success',
                        errorMsg: null
                    }
                });
            });
    }

    validatePassword = (password) => {
        if (password.length < PASSWORD_MIN_LENGTH) {
            return {
                validateStatus: 'error',
                errorMsg: `Girdiğiniz şifre çok kısa (en az  ${PASSWORD_MIN_LENGTH} karakter giriniz.)`
            }
        } else if (password.length > PASSWORD_MAX_LENGTH) {
            return {
                validationStatus: 'error',
                errorMsg: `Girdiğiniz şifre çok uzun  (en fazla ${PASSWORD_MAX_LENGTH} karakter giriniz.)`
            }
        } else {
            return {
                validateStatus: 'success',
                errorMsg: null,
            };
        }
    }

    validatePurpose = (purpose) => {
        if (purpose.length < 6) {
            return {
                validateStatus: 'error',
                errorMsg: `Amaç çok kısa: (en az 6 karakter girilmelidir.)`
            }
        } else if (purpose.length > 40) {
            return {
                validateStatus: 'error',
                errorMsg: `Amaç çok uzun: (en fazla 40 karakter girilmelidir.)`
            }
        } else {
            return {
                validateStatus: 'success',
                errorMsg: null,
            };
        }
    }

}

export default Signup;



// WEBPACK FOOTER //
// ./src/page/signup/Signup.js